import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './counter.module.scss';

const METADATA = Metadata.define({
  description: 'Alert counter badge indicator.',
  name: 'Counter Alert Badge',
});

export default class SpdsIndicatorBadgeCounterAlert extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-indicator-badge-counter';
  variantClass = 'spds-indicator-badge-counter-alert';
  variantStyles = styles;
}

export const BADGE_COUNTER_ALERT_METADATA = SpdsIndicatorBadgeCounterAlert.metadata;
